import {LoaderFunction, redirect} from 'react-router';
import {getById} from '@/repositories/beneva-api/endpoints/allocations';

export const AllocationLoader: LoaderFunction = async ({params}) => {
  if (!params.allocationId) return redirect('/app/profile?tab=allocations');

  return getById(params.allocationId);
};
